import { METHOD } from './method'

export const API = {
    LOGIN: {
        api: '/v1/dashboard-admin/auth/login',
        method: METHOD.POST,
    },
    VERIFY_LOGIN: {
        api: '/v1/dashboard-admin/auth/login/verify',
        method: METHOD.POST,
    },
    LOGOUT: {
        api: '/v1/dashboard-admin/auth/logout',
        method: METHOD.POST,
    },
    FORGOT_PASSWORD: {
        api: '/v1/dashboard-admin/auth/forgot-password',
        method: METHOD.POST,
    },
    HOME: {
        api: '/v1/dashboard-admin/home',
        method: METHOD.GET,
    },
    BITESHIP_SEARCH_AREA: {
        api: '/v1/maps/areas',
        method: METHOD.GET
    },
}
